module.exports = "/_next/static/images/CallToAction3-3413fd1b2e7aa72004c0a10701ff4384.svg";